'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = {
  themeColor: _reactackleCore.colorSecondary,
  gutter: _reactackleCore.tripleBaseModule,
  message: {
    fontSize: function fontSize(_ref) {
      var _fontSize = _ref.fontSize;
      return _fontSize[-1];
    },
    lineHeight: 1.5,
    marginBottom: function marginBottom(_ref2) {
      var baseModule = _ref2.baseModule;
      return baseModule * 4.5;
    },
    color: function color(_ref3) {
      var fontColor = _ref3.fontColor;
      return fontColor.medium;
    },
    backgroundColor: _reactackleCore.colorTransparent,
    paddingY: 0,
    paddingX: 0,
    error: {
      color: function color(_ref4) {
        var _color = _ref4.color;
        return _color.alert;
      },
      backgroundColor: _reactackleCore.colorTransparent,
      paddingY: 0,
      paddingX: 0
    }
  }
};